import { PayloadAction } from '../../../../../store.model';
import { determineAllowedActions } from '../function/determine-allowed-actions.function';
import { filterSummaryByBehaviour } from '../function/filter-summary-by-behaviour.function';
import { filterSummaryByDateRange } from '../function/filter-summary-by-date-range.function';
import { filterSummaryByKeyword } from '../function/filter-summary-by-keyword.function';
import { filterSummaryByParticipant } from '../function/filter-summary-by-participant.function';
import { filterSummaryBySubBehaviour } from '../function/filter-summary-by-sub-behaviour.function';
import { sortSummary } from '../function/sort-summary.function';
import { syncTranscriptIsOpen } from '../function/sync-transcript-is-open.function';
import {
    setBehaviours,
    setParticipants,
    setSubBehaviours,
    setTranscriptCategories,
} from '../function/transcripts-tab.function';
import { ActionType } from '../transcript-summary.action';
import {
    defaultState,
    TranscriptSummaryState,
} from '../transcript-summary.state';

import { Reload, ReloadResult } from './reload.action';

export function reloadReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, Reload>,
): TranscriptSummaryState {
    return {
        ...(action.payload.mode == null ? defaultState() : state),
        pending: {
            ...state.pending,
            reload: true,
        },
    };
}

export function reloadResultReducer(
    state: TranscriptSummaryState,
    action: PayloadAction<ActionType, ReloadResult>,
): TranscriptSummaryState {
    try {
        const transcriptSummary = action.payload.return;
        let transcriptCategories = setTranscriptCategories(
            transcriptSummary,
            action.payload.mode != null,
            state.transcriptCategories,
        );

        let nextFilterOpts = state.filterOpts;
        if (action.payload.mode === 'hard-retain') {
            // TODO revise... should participants/behaviour/subBehaviour filter opts be retained?
            nextFilterOpts = {
                ...state.filterOpts,
                dateRange: {
                    from: action.payload.parameters.startDate,
                    to: action.payload.parameters.endDate,
                },
            };
        }

        let nextFiltered = transcriptCategories;
        if (action.payload.mode != null) {
            filterSummaryByDateRange(
                nextFilterOpts.dateRange,
                state.transcriptCategories,
            );
            nextFiltered = filterSummaryByParticipant(
                state.filterOpts.participant,
                nextFiltered,
            );
            nextFiltered = filterSummaryByBehaviour(
                state.filterOpts.behaviourId,
                nextFiltered,
            );
            nextFiltered = filterSummaryBySubBehaviour(
                state.filterOpts.subBehaviourId,
                nextFiltered,
            );
            nextFiltered = filterSummaryByKeyword(
                state.filterOpts.keyword,
                nextFiltered,
            );
        }

        nextFiltered = sortSummary(state.orderBy, nextFiltered);

        if (action.payload.expandTranscriptIds != null) {
            action.payload.expandTranscriptIds.forEach((e) => {
                transcriptCategories = syncTranscriptIsOpen(
                    transcriptCategories,
                    e,
                    true,
                    true,
                );
                nextFiltered = syncTranscriptIsOpen(
                    nextFiltered,
                    e,
                    true,
                    true,
                );
            });
        }

        const nextFilterParticipants = setParticipants(transcriptCategories);
        const nextFilterBehaviours = setBehaviours(transcriptCategories);
        const nextFilterSubBehaviours = setSubBehaviours(transcriptCategories);

        const nextAllowedActions = determineAllowedActions();

        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
            allowedActions: nextAllowedActions,
            transcriptCategories,
            filteredTranscriptCategories: nextFiltered,
            // enabledAction
            filterOpts: nextFilterOpts,
            filterParticipants: nextFilterParticipants,
            filterBehaviours: nextFilterBehaviours,
            filterSubBehaviours: nextFilterSubBehaviours,
        };
    } catch (err) {
        console.log(err);
        return {
            ...state,
            pending: {
                ...state.pending,
                reload: false,
            },
        };
    }
}
